// Lager-Video — Lazy-Load + Frameless Modal + Mobile Custom Controls
(function () {
  'use strict';
  if (window.__lagerVideoInit) return;
  window.__lagerVideoInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Lazy-Load
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var v = entry.target.querySelector('video');
        if (!v || v.dataset.armed) return;
        v.dataset.armed = '1';
        var src = v.querySelector('source[data-src]');
        if (src && !src.src) { src.src = src.dataset.src; v.load(); }
        if (!reduce) v.play().catch(function(){});
        io.unobserve(entry.target);
      });
    }, { threshold: 0.25 });
    document.querySelectorAll('[data-lazy-video]').forEach(function (el) { io.observe(el); });
  }

  // 2. Modal — frameless, video-only, 8 px radius, integrated close
  function openModal(videoUrl, posterUrl) {
    var existing = document.getElementById('lager-modal');
    if (existing) existing.remove();
    var m = document.createElement('div');
    m.id = 'lager-modal';
    m.innerHTML =
      '<div class="lm-backdrop" aria-label="Schließen"></div>' +
      '<div class="lm-stage">' +
        '<button class="lm-close" type="button" aria-label="Schließen">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
        '</button>' +
        '<video class="lm-video" controls autoplay playsinline preload="auto" poster="'+ (posterUrl||'') +'">' +
          '<source src="'+ videoUrl +'" type="video/mp4">' +
        '</video>' +
      '</div>';
    document.body.appendChild(m);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ m.classList.add('open'); });

    var close = function () {
      m.classList.remove('open');
      setTimeout(function(){ m.remove(); document.body.style.overflow = ''; }, 220);
    };
    m.querySelector('.lm-close').addEventListener('click', close);
    m.querySelector('.lm-backdrop').addEventListener('click', close);
    document.addEventListener('keydown', function esc(e){ if(e.key==='Escape'){close();document.removeEventListener('keydown',esc);} });
  }

  // Bind clicks on triggers
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lager-trigger],[data-modal-video]');
    if (!t) return;
    e.preventDefault();
    var src = t.querySelector && t.querySelector('source[data-src]');
    var videoUrl = t.dataset.modalVideo
                || (src && src.dataset.src)
                || (t.querySelector && t.querySelector('source') && t.querySelector('source').src);
    var poster = t.dataset.modalPoster
                || (t.querySelector && t.querySelector('video') && t.querySelector('video').poster);
    if (videoUrl) openModal(videoUrl, poster);
  });

  // 3. Mobile Custom Controls — Inline-Hochformat-Videos
  document.querySelectorAll('[data-lager-mobile-controls]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    if (!v) return;
    var bar = document.createElement('div');
    bar.className = 'lager-mob-controls';
    bar.innerHTML =
      '<button class="lmc-btn lmc-play" aria-label="Play/Pause"><svg viewBox="0 0 24 24" fill="currentColor"><path class="lmc-i-play" d="M8 5v14l11-7z"/><path class="lmc-i-pause" style="display:none" d="M6 4h4v16H6zm8 0h4v16h-4z"/></svg></button>' +
      '<button class="lmc-btn lmc-mute" aria-label="Ton an/aus"><svg viewBox="0 0 24 24" fill="currentColor"><path class="lmc-i-muted" d="M3 9v6h4l5 5V4L7 9H3zm13.59 3L20 8.41 18.59 7 15 10.59 11.41 7 10 8.41 13.59 12 10 15.59 11.41 17 15 13.41 18.59 17 20 15.59z"/><path class="lmc-i-unmuted" style="display:none" d="M3 9v6h4l5 5V4L7 9H3zm13 .17v5.66l3-3-3-2.66zm-2-7.36v2.05c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.05c4.01-.91 7-4.49 7-8.76s-2.99-7.85-7-8.76z"/></svg></button>' +
      '<button class="lmc-btn lmc-full" aria-label="Vollbild / Sound"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg></button>';
    wrap.appendChild(bar);

    var iPlay = bar.querySelector('.lmc-i-play');
    var iPause= bar.querySelector('.lmc-i-pause');
    var iMute = bar.querySelector('.lmc-i-muted');
    var iUn   = bar.querySelector('.lmc-i-unmuted');

    function syncPlay(){ var p=!v.paused; iPlay.style.display=p?'none':''; iPause.style.display=p?'':'none'; }
    function syncMute(){ iMute.style.display=v.muted?'':'none'; iUn.style.display=v.muted?'none':''; }

    bar.querySelector('.lmc-play').addEventListener('click', function (e){ e.stopPropagation(); v.paused?v.play():v.pause(); syncPlay(); });
    bar.querySelector('.lmc-mute').addEventListener('click', function (e){ e.stopPropagation(); v.muted=!v.muted; if(!v.muted&&v.paused)v.play(); syncMute(); });
    bar.querySelector('.lmc-full').addEventListener('click', function (e){
      e.stopPropagation();
      var src = v.querySelector('source[data-src]');
      var url = (src && src.dataset.src) || (src && src.src) || v.currentSrc;
      openModal(url, v.poster);
    });
    v.addEventListener('play', syncPlay); v.addEventListener('pause', syncPlay);
    v.addEventListener('volumechange', syncMute);
    syncPlay(); syncMute();
  });

  // 4. Modal CSS — frameless, integrated close button on the video
  if (!document.getElementById('lager-modal-style')) {
    var s = document.createElement('style');
    s.id = 'lager-modal-style';
    s.textContent =
      '#lager-modal{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .22s ease}'+
      '#lager-modal.open{opacity:1}'+
      '#lager-modal .lm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.92);backdrop-filter:blur(8px);cursor:pointer}'+
      '#lager-modal .lm-stage{position:relative;width:auto;max-width:min(95vw,520px);max-height:92vh;display:flex;align-items:center;justify-content:center;transform:scale(.96);transition:transform .22s ease}'+
      '#lager-modal.open .lm-stage{transform:scale(1)}'+
      '#lager-modal .lm-video{width:100%;max-width:520px;max-height:92vh;border-radius:8px;background:#000;display:block;outline:0}'+
      '#lager-modal .lm-close{position:absolute;top:10px;right:10px;width:38px;height:38px;border-radius:50%;background:rgba(0,0,0,.6);border:0;color:#fff;cursor:pointer;display:grid;place-items:center;backdrop-filter:blur(6px);transition:background .2s,transform .2s;z-index:2}'+
      '#lager-modal .lm-close:hover{background:rgba(0,0,0,.85);transform:scale(1.05)}'+
      '@media (max-width:600px){#lager-modal .lm-stage{max-width:100vw;width:100%;max-height:100vh}#lager-modal .lm-video{max-width:100vw;max-height:100vh;border-radius:0}#lager-modal .lm-close{top:14px;right:14px;width:42px;height:42px}}'+

      '.lager-mob-controls{position:absolute;bottom:8px;left:8px;right:8px;display:flex;gap:6px;justify-content:flex-end;pointer-events:auto;z-index:3}'+
      '.lager-mob-controls .lmc-btn{width:36px;height:36px;border-radius:50%;border:0;background:rgba(0,0,0,.55);color:#fff;display:grid;place-items:center;cursor:pointer;backdrop-filter:blur(4px);transition:background .2s}'+
      '.lager-mob-controls .lmc-btn:hover{background:rgba(0,0,0,.75)}'+
      '.lager-mob-controls .lmc-btn svg{width:18px;height:18px}';
    document.head.appendChild(s);
  }
})();
